import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LocalizedString } from "app/inscription/store/cotisation-form/inscription.model";

@Pipe({
    name: 'localized', pure: false,
    standalone: false
})
export class LocalizedStringPipe implements PipeTransform {
  constructor(private translate: TranslateService) { }
  transform(value: LocalizedString) {
    return !!value ? value[this.translate.currentLang] : 'N/A';
  }
}